import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router';
import { t } from '../../../../locales';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import classNames from 'classnames';

import { isApp } from '../../../../utils/';
import ContentWrapper from '../../../../components/ContentWrapper/';
import InnerWrapper from '../../../../components/InnerWrapper/';
import ImageText from '../../../../components/ImageText/';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import {
  getCampaignDetail,
  getIsGetTrackerStatus,
  getAxagoalLoading,
} from '../../selectors/vhisSelectors';
import TrackerConnectModalView from '../../components/TrackerConnectModalView';
import { updateIsGetTrackerStatus } from '../../actions/vhisAction';
import { select } from '../../../../stores';
import { getToken } from '../../../../selectors/authSelectors';
import { getValidToken } from '../../../../utils/';

// import image
import StepIcon from '../../../../assets/images/vhis/steps@3x.png';
import TrackerIcon from '../../../../assets/images/vhis/tracker@3x.png';
import Infoblue from '../../../../assets/images/vhis/infoBlue@3x.png';
import EarlyBird from '../../../../assets/images/vhis/icon--early-bird.png';
import './style.scss';
import LoadingView from '../../../../components/LoadingView';
declare let dataLayer: any;

interface ProgressScreenProps {
  match: {
    params: {
      id: string;
      entityCode: string;
    };
  };
  campaignDetail: {
    displayYearData: [
      {
        id: string;
        month: string;
        days: number;
      },
    ];
    totalBonusDays: string;
    totalAchievedDays: number;
    membershipStartDate: string;
    membershipEndDate: string;
    policyEffectiveDate: string;
    policyTerminationDate: string;
    displayIcon: string;
    displayTxt: string;
    currentAchievedDays: number;
    targetAchievedDays: number;
    targetAchievedDisplayIcon: string;
    targetAchievedDisplayTxt: string;
    nextVhisType: string;
    maxReached: boolean;
    earlybirdBonusAchievedDays: string;
    bonusAchievedDays: string;
  };
  isGetTrackerStatus: boolean;
  setIsGetTrackerStatus: (isGetTrackerStatus: boolean) => void;
  isLoading: boolean;
}

interface State {
  showInformationModal: boolean;
  isShowTrackerModal: boolean;
  isTrackerDisconnected: boolean;
  connectedDevices: Array<any>;
}

class ProgressScreen extends Component<
  ProgressScreenProps & RouteComponentProps,
  State
> {
  constructor(props: any) {
    super(props);
    this.toggleInformationModal = this.toggleInformationModal.bind(this);
    this.goToAppView = this.goToAppView.bind(this);
    this.closeTrackerConnectModal = this.closeTrackerConnectModal.bind(this);
    this.handleEmmaMobileMessage = this.handleEmmaMobileMessage.bind(this);
    this.showTrackerPopUp = this.showTrackerPopUp.bind(this);
  }

  state: Readonly<State> = {
    showInformationModal: false,
    isShowTrackerModal: false,
    isTrackerDisconnected: false,
    connectedDevices: [],
    // TODO: delete test data
    // isShowTrackerModal: true,
    // isTrackerDisconnected: true
  };

  goToAppView(url: string) {
    const tcWindow: any = window;
    const token = select(getToken);
    const aToken = getValidToken(token);
    try {
      tcWindow.dataLayer.push({
        event: 'healthKeeper',
        AXAID: aToken,
      });
    } catch (e) {
      console.error(e);
    }
    if (isApp()) {
      EmmaFactory.createInstance().then((e) => {
        e.instance.goTo(url);
      });
    }
  }

  dataMomentFormat(date: string) {
    return moment(date).format('DD/MM/YYYY');
  }

  toggleInformationModal() {
    this.setState({
      showInformationModal: !this.state.showInformationModal,
    });
  }

  componentDidMount() {
    //TODO:[HKEMMA-22405] delete test data
    // this.showTrackerPopUp(true, ['Fitbit', 'Garmin Connect', 'Apple Health', 'Google Fit']);
    if (isApp()) {
      const title = t(`AXA_GOAL_TITLE`);
      if (title) {
        EmmaFactory.createInstance().then((p) =>
          p.instance.setNavigationTitle(title),
        );
      }
      document.addEventListener(
        'reactNativeMessage',
        this.handleEmmaMobileMessage,
      );
    }
  }

  componentWillUnmount() {
    if (isApp()) {
      document.removeEventListener(
        'reactNativeMessage',
        this.handleEmmaMobileMessage,
      );
      this.props.setIsGetTrackerStatus(false);
    }
  }

  closeTrackerConnectModal() {
    this.setState({ isShowTrackerModal: false });
  }

  handleEmmaMobileMessage(event: any) {
    try {
      const { isGetTrackerStatus, setIsGetTrackerStatus } = this.props;
      const message = JSON.parse(event.detail);
      if (
        !isGetTrackerStatus &&
        message.action &&
        message.action.indexOf('@EMMA_MOBILE/') === 0
      ) {
        if (message.action === '@EMMA_MOBILE/TRACKER_STATUS') {
          if (message.payload.isConnected) {
            this.showTrackerPopUp(true, message.payload.connectedDevices);
          } else {
            this.showTrackerPopUp(false, []);
          }
          setIsGetTrackerStatus(true);
        }
      }
    } catch (err) {
      return false;
    }
  }

  showTrackerPopUp(isTrackerConnect: boolean, connectedDevices: Array<any>) {
    this.setState({
      isShowTrackerModal: true,
      isTrackerDisconnected: !isTrackerConnect,
      connectedDevices: connectedDevices,
    });
  }

  render() {
    // TODO:[HKEMMA-22405] delete test data
    // const checkIsApp = true;
    const checkIsApp = isApp();
    const {
      displayIcon,
      displayTxt,
      currentAchievedDays,
      targetAchievedDays,
      targetAchievedDisplayIcon,
      targetAchievedDisplayTxt,
      nextVhisType,
      totalBonusDays,
      membershipStartDate,
      membershipEndDate,
      maxReached,
      policyEffectiveDate,
      policyTerminationDate,
      earlybirdBonusAchievedDays,
      bonusAchievedDays,
    } = this.props.campaignDetail;
    const {
      showInformationModal,
      isShowTrackerModal,
      isTrackerDisconnected,
      connectedDevices,
    } = this.state;
    const { isLoading } = this.props;
    const { id, entityCode } = this.props.match.params;
    const vhisAsClasses = classNames({
      'vhis-as': true,
      'vhis-as--withPaddingBottom': !checkIsApp,
    });
    const offsetWidth = document.body.offsetWidth;
    const isWidthLess375 = offsetWidth < 375;
    const membershipPeriod = `${this.dataMomentFormat(
      membershipStartDate,
    )} - ${this.dataMomentFormat(membershipEndDate)}`;

    return (
      <div className={vhisAsClasses}>
        {isLoading && !isShowTrackerModal && <LoadingView />}
        {checkIsApp && isShowTrackerModal && (
          <TrackerConnectModalView
            isTrackerDisconnected={isTrackerDisconnected}
            connectedDevices={connectedDevices}
            membershipPeriod={membershipPeriod}
            closeVhisModal={this.closeTrackerConnectModal}
          />
        )}
        {showInformationModal && (
          <div className="informaton-modal">
            <div className="informaton-modal__wrapper">
              <div className="informaton-modal__wrapper__title">
                {parseInt(totalBonusDays) === 50 && (
                  <span>{t('ACHIEVEMENT_SUMMARY_MODAL_TITLE')}</span>
                )}
                {parseInt(totalBonusDays) === 75 && (
                  <span>{t('ACHIEVEMENT_SUMMARY_MODAL_TITLE2')}</span>
                )}
              </div>
              <div className="informaton-modal__wrapper__content">
                {parseInt(totalBonusDays) === 50 && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: memoSanitize(
                        t(`ACHIEVEMENT_SUMMARY_MODAL_CONTENT1`),
                      ),
                    }}
                  ></p>
                )}
                {parseInt(totalBonusDays) === 75 && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: memoSanitize(
                        t(`ACHIEVEMENT_SUMMARY_MODAL_CONTENT2`),
                      ),
                    }}
                  ></p>
                )}
              </div>
              <div className="informaton-modal__wrapper__button">
                <button
                  onClick={() => {
                    this.toggleInformationModal();
                  }}
                  data-enable-ga
                  data-ga-type="button"
                >
                  {t('ACHIEVEMENT_SUMMARY_MODAL_BTN')}
                </button>
              </div>
            </div>
            <div
              className="informaton-modal__bg"
              onClick={() => {
                this.toggleInformationModal();
              }}
              data-enable-ga
              data-ga-type="button"
            ></div>
          </div>
        )}
        <ContentWrapper>
          {/* Achievement page in progress start */}
          <div
            className={`vhis-as vhis-as--app ${
              !checkIsApp ? 'vhis-as--margin24' : ''
            }`}
          >
            {/* wrapper start */}
            <div className="vhis-as--app__wrapper">
              <div className="inner-content--wrapper">
                <InnerWrapper>
                  {/* row start */}
                  <div className="row">
                    <div
                      className={`col ${
                        checkIsApp ? 'col-6 col-sm-6' : 'col-12 col-sm-12'
                      }`}
                    >
                      <p className="small mt-0 vhis-as--app__policy-year">
                        {t('MEMBERSHIP_PERIOD')}{' '}
                        {!(checkIsApp && isWidthLess375) && <br />}
                        {this.dataMomentFormat(
                          membershipStartDate ? membershipStartDate : '',
                        )}{' '}
                        -{' '}
                        {this.dataMomentFormat(
                          membershipEndDate ? membershipEndDate : '',
                        )}
                      </p>
                    </div>
                    {checkIsApp && (
                      <div className="col col-6 col-sm-6 text-right">
                        <button
                          className="icon-text icon-text--change-tracker"
                          onClick={() => {
                            this.goToAppView('health-keeper/tracker');
                          }}
                          data-enable-ga
                          data-ga-type="button"
                        >
                          <span className="icon-text__icon icon-text__icon--tacker">
                            <img src={TrackerIcon} alt="" />
                          </span>
                          <span className="icon-text__txt">
                            {t('CHANGE_TRACKER')}
                          </span>
                        </button>
                      </div>
                    )}
                  </div>
                  {/* row end */}
                  <div
                    className={`${
                      checkIsApp && isTrackerDisconnected
                        ? 'tracker-greyed-out'
                        : ''
                    }`}
                  >
                    <div className="vhis-as--app__centerImg vhis-as--app__centerImg--step">
                      <img src={StepIcon} alt="" />
                    </div>
                    {/* counter start */}
                    <div className="vhis-as--app__counter">
                      <div className="vhis-as--app__counter__current">
                        {currentAchievedDays}
                        <div className="vhis-as--app__counter__current__total">
                          /{targetAchievedDays}
                        </div>
                        {(parseInt(totalBonusDays) === 50 ||
                          parseInt(totalBonusDays) === 75) && (
                          <button
                            className="vhis-as--app__counter__current__info"
                            onClick={() => {
                              this.toggleInformationModal();
                            }}
                            data-enable-ga
                            data-ga-type="button"
                          >
                            <img src={Infoblue} alt="" />
                          </button>
                        )}
                      </div>
                      <div className="vhis-as--app__counter__detail">
                        {t('ACHIEVED_DAYS')}
                      </div>
                      <div className="vhis-as--app__counter__remark">
                        {t('ACHIEVEMENT_SUMMARY_REMARK')}
                      </div>
                      {parseInt(earlybirdBonusAchievedDays) > 0 && (
                        <div className="vhis-as--app__counter__extra-bonus">
                          <img src={EarlyBird} alt="" />
                          {t('ACHIEVEMENT_SUMMARY_MODAL_TITLE2')}
                        </div>
                      )}
                    </div>
                    {/* counter end */}

                    {/* progressBar start */}
                    <div className="vhis-as--app__progressBar__wrapper">
                      <div className="vhis-as--app__progressBar">
                        <div className="vhis-as--app__progressBar__start">
                          <img src={displayIcon} alt="" />
                          <p className="small">{t(displayTxt)}</p>
                        </div>
                        <div className="vhis-as--app__progressBar__status">
                          <div className="vhis-as--app__progressBar__status__bar">
                            <div
                              className="vhis-as--app__progressBar__status__bar__active"
                              style={{
                                width:
                                  (currentAchievedDays / targetAchievedDays) *
                                    100 +
                                  `%`,
                              }}
                            >
                              <div className="vhis-as--app__progressBar__status__bar__active__num">
                                {currentAchievedDays}/{targetAchievedDays}
                              </div>
                            </div>
                            <div className="vhis-as--app__progressBar__status__bar__num">
                              {currentAchievedDays}/{targetAchievedDays}
                            </div>
                          </div>
                          <div className="vhis-as--app__progressBar__status__remark">
                            {t('ACHIEVED_DAYS2')}
                          </div>
                        </div>
                        <div className="vhis-as--app__progressBar__end">
                          <img src={targetAchievedDisplayIcon} alt="" />
                          <p className="small">{t(targetAchievedDisplayTxt)}</p>
                        </div>
                      </div>
                    </div>
                    {/* progressBar end */}
                    {checkIsApp && isTrackerDisconnected && (
                      <div className="tracker-modal__bg"></div>
                    )}
                  </div>

                  <p className="text-center small vhis-as__membership__btn">
                    <Link
                      className="vhis__btn"
                      to={'/home/life/axagoal/summary/' + id + '/' + entityCode}
                      data-enable-ga
                      data-ga-type="button"
                    >
                      {t('ACHIEVEMENTSUMMARYTITLE')}
                    </Link>
                  </p>
                  <p className="vhis-as__content--xsmall text-center vhis-as__membership__date-end">
                    {t('POLICT_YEAR')}:{' '}
                    {this.dataMomentFormat(policyEffectiveDate)} -{' '}
                    {this.dataMomentFormat(policyTerminationDate)}
                  </p>
                  <hr />
                  <div className="vhis-rc">
                    {/* <div>
                      {t('AXA_GOAL_REMARK_LINE1')}
                      <b>{t('AXA_GOAL_REMARK_LINE1_42_DAYS')}</b>
                      {t('AXA_GOAL_REMARK_LINE1_42_DAYS_AFTER_TEXT')}
                    </div>
                    <br /> */}
                    <div>
                      {t('AXA_GOAL_REMARK_LINE2')}
                      <b>
                        {t('AXA_GOAL_REMARK_LINE2_CUSTOMER_SERVICE_HOTLINE')}
                      </b>
                      {t('AXA_GOAL_REMARK_LINE2_CUSTOMER_SERVICE_HOTLINE_ON')}
                      <b>
                        {t(
                          'AXA_GOAL_REMARK_LINE2_CUSTOMER_SERVICE_HOTLINE_NUMBER',
                        )}
                      </b>
                      {t(
                        'AXA_GOAL_REMARK_LINE2_CUSTOMER_SERVICE_HOTLINE_NUMBER_FULL_STOP',
                      )}
                    </div>
                    <br />
                    <div>
                      {t('AXA_GOAL_REMARK_LINE3_CLICK_TEXT')}
                      <a
                        className="vhis-rc--linkcolor"
                        href={t('AXA_GOAL_REMARK_LINE3_LINK')}
                        target="_blank"
                        data-enable-ga
                        data-ga-type="link"
                        rel="noreferrer"
                      >
                        <b>{t('AXA_GOAL_REMARK_LINE3_HERE_TEXT')}</b>
                      </a>
                      {t('AXA_GOAL_REMARK_LINE3_LINK_AFTER_TEXT')}
                    </div>
                  </div>
                </InnerWrapper>
              </div>
            </div>
            {/* wrapper end */}

            {/* wrapper start */}
            <InnerWrapper>
              <div className="vhis-as--app__wrapper">
                <div className="inner-content--wrapper ta-lg-c">
                  {maxReached ? (
                    <p className="vhis-as__subtitle">
                      <b>{t('YOUR_ULTIMATE_LEVEL')}</b>
                    </p>
                  ) : (
                    <p className="vhis-as__subtitle">
                      <b>{t('YOUR_NEXT_LEVEL')}</b>
                    </p>
                  )}
                  <ImageText
                    large={false}
                    small={false}
                    vertical={false}
                    imgSrc={targetAchievedDisplayIcon}
                    imgAlt={targetAchievedDisplayTxt}
                  >
                    <p className="vhis-as__subtitle vhis-as__subtitle--mb0">
                      <b>{t(nextVhisType)}</b>
                    </p>
                    <p className="image-text__txt__content">
                      <b>{t(nextVhisType + '_CONTENT_DAYS')}</b>
                      <span className="image-text__txt__content--small">
                        /{t('MEMBERSHIP_YEAR')}
                      </span>
                    </p>
                    <p className="image-text__txt__content ">
                      {t(nextVhisType + '_CONTENT_DISCOUNT')}
                    </p>
                    <p className="image-text__txt__content">
                      <Link
                        className="image-text__txt__link"
                        to={'/home/life/axagoal/rules/'}
                        data-enable-ga
                        data-ga-type="button"
                      >
                        {t('RULES_AND_REGULATIONS')}
                      </Link>
                    </p>
                  </ImageText>
                </div>
              </div>
            </InnerWrapper>
            {/* wrapper end */}

            {/* wrapper start */}
            {checkIsApp && (
              <InnerWrapper theme="blue" noMarginBtm={true}>
                <div className="vhis-as--app__wrapper vhis-as--app__wrapper--mb0 vhis-as__blue-wrapper">
                  <div className="inner-content--wrapper">
                    <p className="vhis-as__subtitle">
                      <b>{t('MAKE_STEP_CHALLENGE_FUN_TITLE')}</b>
                    </p>
                    <p className="vhis-as__content">
                      {t('MAKE_STEP_CHALLENGE_FUN_CONTENT')}
                    </p>
                    <p className="vhis-as__content text-center small">
                      <button
                        className="vhis__btn vhis__btn--white--outline"
                        onClick={() => {
                          this.goToAppView(
                            'emma-common?disclaimer=healthKeeperChallengeNew',
                          );
                        }}
                        data-enable-ga
                        data-ga-type="button"
                      >
                        {t('START_NOW')}
                      </button>
                    </p>
                  </div>
                </div>
                {/* wrapper end */}
              </InnerWrapper>
            )}
          </div>
          {/* Achievement page in progress end */}
        </ContentWrapper>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const campaignDetailData = getCampaignDetail(state);
    const isGetTrackerStatus = getIsGetTrackerStatus(state);
    const isLoading = getAxagoalLoading(state);
    return {
      campaignDetail: Object.assign({}, campaignDetailData),
      isGetTrackerStatus,
      isLoading,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      setIsGetTrackerStatus: (isGetTrackerStatus: boolean) =>
        dispatch(updateIsGetTrackerStatus(isGetTrackerStatus)),
    };
  }
}

export default connect(
  ProgressScreen.mapStateToProps,
  ProgressScreen.mapDispatchToProps,
)(ProgressScreen);
